module.exports = __webpack_public_path__ + "static/aws-54a7aa627cae7fab15a9aebbe79288e1.jpeg";